import Immutable from 'immutable';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import * as colors from 'material-ui/styles/colors';
import uuidV4 from 'uuid/v4';

export default Immutable.fromJS({
    site: {
        drawers: {
            leftDrawer: false,
            footerMenu: false,
            messageDrawer: false
        },
        showArrivalTimeDialog: false,
        orderDetailType: 'swipe',
        theme: getMuiTheme(),
        themeModifier: {
            palette: {
                primary1Color: colors.blue500,
                primary2Color: colors.blue700,
                primary3Color: colors.grey400,
                accent1Color: colors.pinkA200,
                accent2Color: colors.grey100,
                accent3Color: colors.grey500
            }
        }
    },
    user: {
        instanceId: uuidV4(),
        vehicleValidationResults: {
            isValid: true,
            errors: []
        },
        vehicleNumber: '12345',
        vehicleSaved: true,
        isEditingStatus: false,
        isLoggedIn: false,
        nextArrivalTime: null,
        userId: '',
        name: ''
    },
    transactionLog: {
        logs: []
    },
    message: {
        cannedMessages: [],
        messagePanelCollapsed: true,
        alert: {
            alerts: []
        }
    },
    workOrder: {
        workOrderDetails: {},
        showClosedOrders: false
    },
    techData: {
        techSearch: {
            searchLoading: false,
            searchFinished: true,
            searchCriteria: null,
            topMatch: null,
            techSearchResults: {},
            techWorkOrdersLoading: false
        },
        techs: {}
    },
    error: {
        currentErrors: []
    },
    provisioning: {
        servicesSearch: {
            loading: false,
            loadingFinished: true,
            error: null
        },
        provisioningSearch: {
            loading: false,
            loadingFinished: true,
            error: null
        },
        details: {}
    },
    pubNubToken: null
});



// WEBPACK FOOTER //
// ./src/reducers/initialState.js